export const tooltipButtons = {
    next: {
      en: "Next",
      hi: "आगे बढ़ें",
      or: "ଆଗକୁ",
      mr: "पुढे जा"
    },
    previous: {
      en: "Previous",
      hi: "पीछे जाएं",
      or: "ପୂର୍ବ",
      mr: "पिछ्या"
    },
    skip: {
      en: "Skip",
      hi: "स्किप करें",
      or: "ଛାଡିଦିଅନ୍ତୁ",
      mr: "छोड़ा"
    },
    stop: {
      en: "Stop the speaker",
      hi: "स्पीकर बंद करें",
      or: "ସ୍ପିକର୍ ବନ୍ଦ କରନ୍ତୁ",
      mr: "स्पीकर बंद करा"
    },
    finish: {
      en: "Get Started",
      hi: "ऐप चलना शुरू करें",
      or: "ଆରମ୍ଭ କରନ୍ତୁ",
      mr: "शुरू करा"
    },
    backToChat: {
      en: "Back to Chat",
      hi: "चैट पर वापस जाएं",
      or: "ଚାଟ୍‌କୁ ଫେରିଯାଆନ୍ତୁ",
      mr: "चॅटवर परत जा"
  },
  TooltipStart: {
    en: "Learn again",
    hi: "फिर से सीखें",
    or: "ପୁଣିଥରେ ଶିଖନ୍ତୁ",
    mr: "पुन्हा शिका"
  }
  };

export const learnAgainText = {
  en: "Learn again",
  hi: "फिर सीखें",
  or: "ପୁଣି ଶିଖନ୍ତୁ",
  mr: "पुन्हा शिका"
};

export const introHeading1 = {
  en: "Learn to use",
  hi: "हेल्थवाणी",
  or: "ହେଲ୍‌ଥବାଣୀ",
  mr: "हेल्थवाणी"
}
export const introHeading2 = {
  en: "HealthVaani",
  hi: "चलाना सीखें",
  or: "ବ୍ୟବହାର କରିବାକୁ ଶିଖନ୍ତୁ",
  mr: "वापरायला शिका"
}
export const tooltipIntroContent = {
    en: "Learn to use HealthVaani in minutes! Practice along with me and don’t pause midway.",
    hi: "मेरे साथ मिनटों में हेल्थवाणी चलाना सीखें! आप साथ-साथ आज़माएँ और बीच में बंद ना करें!",
    or: "ମାତ୍ର କିଛି ମିନିଟରେ ହେଲ୍‌ଥବାଣୀ ବ୍ୟବହାର କରିବାକୁ ଶିଖନ୍ତୁ! ମୋ ସହିତ ଅଭ୍ୟାସ କରନ୍ତୁ ଏବଂ ଅଧାରୁ ଅଟକି ଯାଆନ୍ତୁ ନାହିଁ।",
    mr: "काही मिनिटांमध्ये हेल्थवाणी वापरायला शिका! माझ्यासोबत सराव करा आणि मध्येच थांबू नका."
}
export const introAudioContent = {
  en: "Learn to use Healthvaani. Learn to use HealthVaani in minutes! Practice along with me and don’t pause midway.",
  hi: "हेल्थवाणी चलाना सीखें. मेरे साथ मिनटों में हेल्थवाणी चलाना सीखें! आप साथ-साथ आज़माएँ और बीच में बंद ना करें!",
  or: "ହେଲ୍‌ଥବାଣୀ ବ୍ୟବହାର କରିବାକୁ ଶିଖନ୍ତୁ. ମାତ୍ର କିଛି ମିନିଟରେ ହେଲ୍‌ଥବାଣୀ ବ୍ୟବହାର କରିବାକୁ ଶିଖନ୍ତୁ! ମୋ ସହିତ ଅଭ୍ୟାସ କରନ୍ତୁ ଏବଂ ଅଧାରୁ ଅଟକି ଯାଆନ୍ତୁ ନାହିଁ।",
  mr: "हेल्थवाणी वापरायला शिका. काही मिनिटांमध्ये हेल्थवाणी वापरायला शिका! माझ्यासोबत सराव करा आणि मध्येच थांबू नका."
}
export const speakerHeading1 = {
  en: "Don’t just read,",
  hi: "सिर्फ पढें नहीं,",
  or: "କେବଳ ପଢ଼ନ୍ତୁ ନାହିଁ,",
  mr: "फक्त वाचू नका,"
}
export const speakerHeading2 = {
  en: "listen too",
  hi: "सुनें भी।",
  or: "ଶୁଣନ୍ତୁ ମଧ୍ୟ",
  mr: "ऐकासुद्धा"
}
export const tooltipSpeakerContent = {
    en: "You can hear messages on HealthVaani with 'speaker button' shown above",
    hi: "हेल्थवाणी पर कोई भी मैसेज ऊपर बनें ‘स्पीकर बटन’ को दबाकर सुनें",
    or: "ଉପରେ ଦେଖାଯାଉଥିବା ସ୍ପିକର୍ ବଟନ୍ ଦ୍ୱାରା ଆପଣ ହେଲ୍‌ଥବାଣୀରେ ମେସେଜ୍ ଶୁଣିପାରିବେ।",
    mr: "वर दाखवलेले 'स्पीकर बटण' वापरून तुम्ही हेल्थवाणीवर मॅसेज ऐकू शकता"
}
export const speakerAudioContent = {
  en: "Don’t just read, listen too. You can hear messages on HealthVaani with speaker button shown above",
  hi: "सिर्फ पढें नहीं, सुनें भी। हेल्थवाणी पर कोई भी मैसेज ऊपर बनें ‘स्पीकर बटन’ को दबाकर सुनें",
  or: "କେବଳ ପଢ଼ନ୍ତୁ ନାହିଁ, ଶୁଣନ୍ତୁ ମଧ୍ୟ. ଉପରେ ଦେଖାଯାଉଥିବା ସ୍ପିକର୍ ବଟନ୍ ଦ୍ୱାରା ଆପଣ ହେଲ୍‌ଥବାଣୀରେ ମେସେଜ୍ ଶୁଣିପାରିବେ।",
  mr: "फक्त वाचू नका, ऐकासुद्धा. वर दाखवलेले 'स्पीकर बटण' वापरून तुम्ही हेल्थवाणीवर मॅसेज ऐकू शकता"
}
export const inputHeading1 = {
  en: "Ask anything",
  hi: "जो चाहें,",
  or: "ଆପଣ ଯାହା,",
  mr: "तुम्हाला हवे"
}
export const inputHeading2 = {
  en: "you want.",
  hi: "वो पूछें।",
  or: "ଚାହିଁବେ ପଚାରନ୍ତୁ।",
  mr: "ते विचारा."
}
export const tooltipInputContent = {
  en: "Type any question you want - HealthVaani understands even small typing mistakes.",
  hi: "मनचाहा सवाल टाइप करके पूछें- लिखने की छोटी गलतियों को भी हेल्थवाणी समझ लेगी।",
  or: "ଆପଣ ଯେକୌଣସି ପ୍ରଶ୍ନ ଟାଇପ୍ କରନ୍ତୁ - ହେଲ୍‌ଥବାଣୀ ଛୋଟ ଟାଇପିଂ ଭୁଲ୍ ମଧ୍ୟ ବୁଝିପାରେ।",
  mr: "तुम्हाला हवा तो प्रश्न टाइप करा - हेल्थवाणीला अगदी लहान टायपिंग चुका देखील समजतात."
}
export const inputAudioContent = {
  en: "Ask anything You Want. Type any question you want. HealthVaani understands even small typing mistakes.",
  hi: "जो चाहें, वो पूछें। मनचाहा सवाल टाइप करके पूछें. लिखने की छोटी गलतियों को भी हेल्थवाणी समझ लेगी।",
  or: "ଆପଣ ଯାହା ଚାହିଁବେ ପଚାରନ୍ତୁ। ଆପଣ ଯେକୌଣସି ପ୍ରଶ୍ନ ଟାଇପ୍ କରନ୍ତୁ - ହେଲ୍‌ଥବାଣୀ ଛୋଟ ଟାଇପିଂ ଭୁଲ୍ ମଧ୍ୟ ବୁଝିପାରେ।",
  mr: "तुम्हाला जे काही विचारायचे आहे ते विचारा. तुम्हाला हवा तो प्रश्न टाइप करा - हेल्थवाणीला अगदी लहान टायपिंग चुका देखील समजतात."
}
export const sendHeaning1 = {
  en: "Send question",
  hi: "उत्तर पाने के लिए",
  or: "ଉତ୍ତର ପାଇବା ପାଇଁ",
  mr: "उत्तर मिळविण्यासाठी"
}
export const sendHeaning2 = {
  en: "to get an answer",
  hi: "सवाल भेजें",
  or: "ପ୍ରଶ୍ନ ପଠାନ୍ତୁ",
  mr: "प्रश्न पाठवा"
}
export const tooltipSendContent = {
  en: "Tap the ‘Send’ button shown below to submit your question.",
  hi: "उत्तर पाने के लिए सवाल नीचे दिखाए ‘सेंड बटन’ को दबाकर आगे भेजें।",
  or: "ଆପଣଙ୍କ ପ୍ରଶ୍ନ ଦାଖଲ କରିବା ପାଇଁ ତଳେ ଦେଖାଯାଉଥିବା ‘ପଠାନ୍ତୁ’ ବଟନ୍‌କୁ ଦବାନ୍ତୁ।",
  mr: "तुमचा प्रश्न सबमिट करण्यासाठी खाली दाखवलेल्या 'सेंड' बटणावर टॅप करा."
}
export const sendAudioContent = {
  en: "Send question to get an answer. Tap the ‘Send’ button shown below to submit your question.",
  hi: "उत्तर पाने के लिए सवाल भेजें. उत्तर पाने के लिए सवाल नीचे दिखाए ‘सेंड बटन’ को दबाकर आगे भेजें।",
  or: "ଉତ୍ତର ପାଇବା ପାଇଁ ପ୍ରଶ୍ନ ପଠାନ୍ତୁ. ଆପଣଙ୍କ ପ୍ରଶ୍ନ ଦାଖଲ କରିବା ପାଇଁ ତଳେ ଦେଖାଯାଉଥିବା ‘ପଠାନ୍ତୁ’ ବଟନ୍‌କୁ ଦବାନ୍ତୁ।",
  mr: "उत्तर मिळविण्यासाठी प्रश्न पाठवा. तुमचा प्रश्न सबमिट करण्यासाठी खाली दाखवलेल्या 'सेंड' बटणावर टॅप करा."
}
export const tooltipSendQuestion = {
  en: "What are the danger signs in a newborn baby?",
  hi: "नवजात शिशु में खतरे के लक्षण क्या हैं?",
  or: "ନବଜାତ ଶିଶୁରେ ଭାଗ୍ୟକାରୀ ଚିହ୍ନଗୁଡ଼ିକ କ’ଣ ହେଉଛି?",
  mr: "नवजात बाळामध्ये धोक्याची लक्षणे कोणती आहेत?"
}
export const MicIntroHeading1 = {
  en: "Speak and ask",
  hi: "बोलकर पूछना",
  or: "କହିକି ପ୍ରଶ୍ନ",
  mr: "बोला आणि"
}
export const MicIntroHeading2 = {
  en: "questions",
  hi: "हुआ आसान।",
  or: "ପଚାରନ୍ତୁ",
  mr: "प्रश्न विचारा"
}
export const MicIntroContent = {
  en: "Don’t just type your question - speak it, and I’ll record it in writing.",
  hi: "सवाल लिखकर ही नहीं, बोलकर भी पूछें - आप जो बोलेंगी, मैं उसे लिखित में दर्ज कर लूँगी ।",
  or: "ଆପଣଙ୍କ ପ୍ରଶ୍ନ କେବଳ ଟାଇପ୍ କରନ୍ତୁ ନାହିଁ - ଏହାକୁ କୁହନ୍ତୁ, ଏବଂ ମୁଁ ଏହାକୁ ଲେଖିକି ରେକର୍ଡ କରିବି।",
  mr: "तुमचा प्रश्न फक्त टाइप करू नका - तो बोला, आणि मी तो लेखी स्वरूपात रेकॉर्ड करेन."
}
export const MicIntroAudioContent = {
  en: "Speak and Ask Questions. Don’t just type your question speak it, and I’ll record it in writing.",
  hi: "बोलकर पूछना हुआ आसान। सवाल लिखकर ही नहीं, बोलकर भी पूछें - आप जो बोलेंगी, मैं उसे लिखित में दर्ज कर लूँगी ",
  or: "କହିକି ପ୍ରଶ୍ନ ପଚାରନ୍ତୁ. ଆପଣଙ୍କ ପ୍ରଶ୍ନ କେବଳ ଟାଇପ୍ କରନ୍ତୁ ନାହିଁ - ଏହାକୁ କୁହନ୍ତୁ, ଏବଂ ମୁଁ ଏହାକୁ ଲେଖିକି ରେକର୍ଡ କରିବି।",
  mr: "बोला आणि प्रश्न विचारा तुमचा प्रश्न फक्त टाइप करू नका - तो बोला, आणि मी तो लेखी स्वरूपात रेकॉर्ड करेन."
}
export const MicHeading1 = {
  en: "Record your",
  hi: "सवाल",
  or: "ଆପଣଙ୍କ ପ୍ରଶ୍ନ",
  mr: "तुमचा प्रश्न"
}
export const MicHeading2 = {
  en: "question",
  hi: "रिकॉर्ड करें",
  or: "ରେକର୍ଡ କରନ୍ତୁ",
  mr: "रेकॉर्ड करा"
}
export const MicContent = {
  en: "Use the ‘mic button’ to record your question in a quiet place and stop when done.",
  hi: "शांत जगह पर ‘माइक बटन’ से सवाल रेकार्ड करें और ख़तम होते ही रिकॉर्डिंग रोकें।",
  or: "ଶାନ୍ତ ସ୍ଥାନରେ ଆପଣଙ୍କ ପ୍ରଶ୍ନ ରେକର୍ଡ କରିବା ପାଇଁ 'ମାଇକ୍ ବଟନ୍' ବ୍ୟବହାର କରନ୍ତୁ ଏବଂ ଶେଷ ହେଲେ ଷ୍ଟପ୍ କରନ୍ତୁ।",
  mr: "शांत ठिकाणी तुमचा प्रश्न रेकॉर्ड करण्यासाठी 'माइक बटण' वापरा आणि पूर्ण झाल्यावर थांबा."
}
export const MicAudioContent = {
  en: "Record Your Question. Use the mic button to record your question in a quiet place and stop when done.",
  hi:"सवाल रिकॉर्ड करें. शांत जगह पर माइक बटन से सवाल रेकार्ड करें और ख़तम होते ही रिकॉर्डिंग रोकें।",
  or: "ଆପଣଙ୍କ ପ୍ରଶ୍ନ ରେକର୍ଡ କରନ୍ତୁ. ଶାନ୍ତ ସ୍ଥାନରେ ଆପଣଙ୍କ ପ୍ରଶ୍ନ ରେକର୍ଡ କରିବା ପାଇଁ 'ମାଇକ୍ ବଟନ୍' ବ୍ୟବହାର କରନ୍ତୁ ଏବଂ ଶେଷ ହେଲେ ଷ୍ଟପ୍ କରନ୍ତୁ।",
  mr: "तुमचा प्रश्न रेकॉर्ड करा शांत ठिकाणी तुमचा प्रश्न रेकॉर्ड करण्यासाठी 'माइक बटण' वापरा आणि पूर्ण झाल्यावर थांबा."
}
export const MicEndHeading1 = {
  en: "Check, edit, and",
  hi: "चेक करें, सुधारें",
  or: "ଯାଞ୍ଚ କରନ୍ତୁ, ଏଡିଟ୍ କରନ୍ତୁ,",
  mr: "तपासा, एडिट करा"
}
export const MicEndHeading2 = {
  en: "get your answer",
  hi: "और उत्तर पाएं",
  or: "ଏବଂ ଆପଣଙ୍କ ଉତ୍ତର ପାଆନ୍ତୁ",
  mr: "आणि तुमचे उत्तर मिळवा"
}
export const MicEndContent = {
  en: "Check how your spoken question is written and edit it by typing if there are any mistakes",
  hi: "जाँच लें कि मैंने आपका बोला गया सवाल ठीक से लिखा है। कोई गलती लगे तो टाइप करके सुधार दें।",
  or: "ଆପଣ କହିଥିବା ପ୍ରଶ୍ନ କିପରି ଲେଖାଯାଇଛି ତାହା ଯାଞ୍ଚ କରନ୍ତୁ ଏବଂ ଯଦି କିଛି ଭୁଲ୍ ଅଛି ତେବେ ଟାଇପ୍ କରି ତାହାକୁ ଏଡିଟ୍",
  mr: "तुम्ही बोललेला प्रश्न मी कसा लिहिला आहे ते तपासा आणि काही चुका असल्यास टाइप करून तो एडिट करा"
}
export const MicEndAudioContent = {
  en: "Check, Edit, and Get Your Answer. Check how your spoken question is written and edit it by typing if there are any mistakes",
  hi: "चेक करें, सुधारें और उत्तर पाएं। जाँच लें कि मैंने आपका बोला गया सवाल ठीक से लिखा है। कोई गलती लगे तो टाइप करके सुधार दें।",
  or: "ଯାଞ୍ଚ କରନ୍ତୁ, ଏଡିଟ୍ କରନ୍ତୁ, ଏବଂ ଆପଣଙ୍କ ଉତ୍ତର ପାଆନ୍ତୁ. ଆପଣ କହିଥିବା ପ୍ରଶ୍ନ କିପରି ଲେଖାଯାଇଛି ତାହା ଯାଞ୍ଚ କରନ୍ତୁ ଏବଂ ଯଦି କିଛି ଭୁଲ୍ ଅଛି ତେବେ ଟାଇପ୍ କରି ତାହାକୁ ଏଡିଟ୍",
  mr: "तपासा, एडिट करा आणि तुमचे उत्तर मिळवा तुम्ही बोललेला प्रश्न कसा लिहिला आहे ते तपासा आणि काही चुका असल्यास टाइप करून तो एडिट करा"
}
export const GridHeading1 = {
  en: "Select a Topic If",
  hi: "विषय चुनें,",
  or: "ନିଜ ପସନ୍ଦର",
  mr: "तुम्हाला हवा असलेला"
}
export const GridHeading2 = {
  en: "You Like",
  hi: "बात करें",
  or: "ଏକ ବିଷୟ ବାଛନ୍ତୁ",
  mr: "विषय निवडा"
}
export const GridContent = {
  en: "Start with example topics if you like. Tap the ‘Topic button’ below and select a topic.",
  hi: "हेल्थवाणी से पूछने के लिए, चाहें तो उदाहरण विषयों से शुरुआत करें। नीचे ‘विषय बटन’ दबाएं और विषय चुनें।",
  or: "ଆପଣ ଚାହିଁଲେ ଉଦାହରଣ ବିଷୟରୁ ଆରମ୍ଭ କରିପାରିବେ। ତଳେ ଥିବା ‘ଟପିକ୍ ବଟନ୍’କୁ ଦବାନ୍ତୁ ଏବଂ ଏକ ବିଷୟ ବାଛନ୍ତୁ।",
  mr: "तुम्हाला वाटल्यास उदाहरणात्मक विषयांसह सुरुवात करा. खालील 'विषय बटणा' वर टॅप करा आणि विषय निवडा."
}
export const GridAudioContent = {
  en: "Select a Topic If You Like. Start with example topics if you like. Tap the Topic button below and select a topic.",
  hi: "विषय चुनें, बात करें. हेल्थवाणी से पूछने के लिए, चाहें तो उदाहरण विषयों से शुरुआत करें। नीचे विषय बटन दबाएं और विषय चुनें।",
  or: "ଯଦି ଆପଣ ଚାହିଁବେ ତେବେ ଏକ ବିଷୟ ବାଛନ୍ତୁ. ଆପଣ ଚାହିଁଲେ ଉଦାହରଣ ବିଷୟରୁ ଆରମ୍ଭ କରିପାରିବେ। ତଳେ ଥିବା ‘ଟପିକ୍ ବଟନ୍’କୁ ଦବାନ୍ତୁ ଏବଂ ଏକ ବିଷୟ ବାଛନ୍ତୁ।",
  mr: "तुम्हाला हवा असलेला विषय निवडा तुम्हाला वाटल्यास उदाहरणात्मक विषयांनी सुरुवात करा. खालील 'विषय बटणा'वर टॅप करा आणि विषय निवडा."
}
export const chipsHeading1 = {
  en: "Select a Topic If",
  hi: "विषय चुनें,",
  or: "ନିଜ ପସନ୍ଦର ",
  mr: "तुम्हाला हवा असलेला"
}
export const chipsHeading2 = {
  en: " You Like",
  hi: "बात करें",
  or: "ଏକ ବିଷୟ ବାଛନ୍ତୁ",
  mr: "विषय निवडा"
}
export const chipsContent = {
  en: "Pick a topic and see related example questions. You ask similar ones anytime.",
  hi: "विषय का चयन करें और ऐसे उदाहरण सवाल देखें जो आप हेल्थवाणी से पूछ सकती हैं। ",
  or: "ଏକ ବିଷୟ ବାଛନ୍ତୁ ଏବଂ ସମ୍ବନ୍ଧିତ ଉଦାହରଣ ପ୍ରଶ୍ନଗୁଡ଼ିକ ଦେଖନ୍ତୁ। ଆପଣ ଯେକୌଣସି ସମୟରେ ସେହିଭଳି ପ୍ରଶ୍ନ ପଚାରିପାରିବେ।",
  mr: "एक विषय निवडा आणि संबंधित प्रश्नांची उदाहरणे पहा. तुम्ही कधीही असेच प्रश्न विचारु शकता."
}
export const chipsAudioContent = {
  en: "Select a Topic If You Like. Pick a topic and see related example questions. You ask similar ones anytime.",
  hi: "विषय चुनें, बात करें. विषय का चयन करें और ऐसे उदाहरण सवाल देखें जो आप हेल्थवाणी से पूछ सकती हैं। ",
  or: "ଯଦି ଆପଣ ଚାହିଁବେ ତେବେ ଏକ ବିଷୟ ବାଛନ୍ତୁ. ଏକ ବିଷୟ ବାଛନ୍ତୁ ଏବଂ ସମ୍ବନ୍ଧିତ ଉଦାହରଣ ପ୍ରଶ୍ନଗୁଡ଼ିକ ଦେଖନ୍ତୁ। ଆପଣ ଯେକୌଣସି ସମୟରେ ସେହିଭଳି ପ୍ରଶ୍ନ ପଚାରିପାରିବେ।",
  mr: "तुम्हाला हवा असलेला विषय निवडा एक विषय निवडा आणि संबंधित प्रश्नांची उदाहरणे पहा. तुम्ही कधीही असेच प्रश्न विचारु शकता."
}
export const tooltipQuestionChipsHeading1 = {
  en: "Pick a Topic If",
  hi: "विषय चुनें,",
  or: "ନିଜ ପସନ୍ଦର ",
  mr: "तुम्हाला हवा असलेला"
}
export const tooltipQuestionChipsHeading2 = {
  en: "You Wish",
  hi: "बात करें",
  or: "ଏକ ବିଷୟ ବାଛନ୍ତୁ",
  mr: "विषय निवडा"
}
export const tooltipQuestionChipsContent = {
  en: "Pick any question and get an answer. Just like this, ask me any question about your work.",
  hi: "यहाँ सवाल देखें, एक चुनें और उत्तर पाएं। आप अपने कार्य का कोई भी सवाल मुझसे पूछ सकती हैं।",
  or: "ଏକ ବିଷୟ ବାଛନ୍ତୁ ଏବଂ ସମ୍ବନ୍ଧିତ ଉଦାହରଣ ପ୍ରଶ୍ନଗୁଡ଼ିକ ଦେଖନ୍ତୁ। ଆପଣ ଯେକୌଣସି ସମୟରେ ସେହିଭଳି ପ୍ରଶ୍ନ ପଚାରିପାରିବେ।",
  mr: "कोणताही प्रश्न निवडा आणि उत्तर मिळवा. तुमच्या कामाबद्दल मला असेच कोणतेही प्रश्न विचारा."
}
export const tooltipQuestionChipsAudioContent = {
  en: "Pick a Topic If You Wish. Pick any question and get an answer. Just like this, ask me any question about your work",
  hi: "विषय चुनें, बात करें. यहाँ सवाल देखें, एक चुनें और उत्तर पाएं। आप अपने कार्य का कोई भी सवाल मुझसे पूछ सकती हैं।",
  or: "ଯଦି ଆପଣ ଚାହିଁବେ ତେବେ ଏକ ବିଷୟ ବାଛନ୍ତୁ. ଏକ ବିଷୟ ବାଛନ୍ତୁ ଏବଂ ସମ୍ବନ୍ଧିତ ଉଦାହରଣ ପ୍ରଶ୍ନଗୁଡ଼ିକ ଦେଖନ୍ତୁ। ଆପଣ ଯେକୌଣସି ସମୟରେ ସେହିଭଳି ପ୍ରଶ୍ନ ପଚାରିପାରିବେ।",
  mr: "तुम्हाला हवा असलेला विषय निवडा. कोणताही प्रश्न निवडा आणि उत्तर मिळवा. तुमच्या कामाबद्दल मला असेच कोणतेही प्रश्न विचारा."
}
export const tooltipLoaderHeading1 = {
  en: "",
  hi: "लोड हो",
  or: "",
  mr: "लोड होत"
}
export const tooltipLoaderHeading2 = {
  en: "Loading...",
  hi: "रहा है...",
  or: "ଲୋଡ୍ ହେଉଛି...",
  mr: "आहे..."
}
export const tooltipLoaderContent = {
  en: "If the internet is slow, loading may take time",
  hi: "इंटरनेट धीमे होने पर लोड होने में समय लग सकता है।",
  or: "ଇଣ୍ଟରନେଟ୍ ଧୀର ହେଲେ ଲୋଡ୍ ହେବାକୁ ସମୟ ଲାଗିପାରେ।",
  mr: "इंटरनेट संथ असल्यास लोड होण्यासाठी काही वेळ लागू शकतो ।"
}
export const tooltipStarHeading1 = {
  en: "Save answers:",
  hi: "उत्तर सेव करें:",
  or: "ଉତ୍ତରଗୁଡ଼ିକୁ ସଞ୍ଚୟ କରନ୍ତୁ:",
  mr: "उत्तरे सेव्ह करा:"
}
export const tooltipStarHeading2 = {
  en: " Star them",
  hi: "स्टार करें",
  or: "ସେଗୁଡ଼ିକୁ ଷ୍ଟାର ଚିହ୍ନ ଦିଅନ୍ତୁ",
  mr: "स्टार करा"
}
export const tooltipStarContent = {
  en: "If you like an answer, tap the ‘star button’ to highlight when scrolling past answers.",
  hi: "उत्तर अच्छा लगे तो उसके पास बना ‘स्टार बटन’ दबाएं, पुराने उत्तर देखते समय यह आपको अलग से दिखेगा।",
  or: "ଯଦି ଆପଣଙ୍କୁ କୌଣସି ଉତ୍ତର ପସନ୍ଦ ଆସେ, ତେବେ ଉତ୍ତରଗୁଡ଼ିକୁ ସ୍କ୍ରୋଲ୍ କରିବା ବେଳେ ତାହାକୁ ହାଇଲାଇଟ୍ କରିବା ପାଇଁ 'ଷ୍ଟାର୍ ବଟନ୍'କୁ ଦବାନ୍ତୁ।",
  mr: "जर तुम्हाला उत्तर आवडले असेल तर त्यांना स्टार करा, मागील उत्तरे स्क्रोल करताना हायलाइट करण्यासाठी 'स्टार बटण' दाबा."
}
export const tooltipStarAudioContent = {
  en: "Save answers: Star them. If you like an answer, tap the ‘star button’ to highlight when scrolling past answers.",
  hi: "उत्तर सेव करें: स्टार करें. उत्तर अच्छा लगे तो उसके पास बना ‘स्टार बटन’ दबाएं, पुराने उत्तर देखते समय यह आपको अलग से दिखेगा।",
  or: "ଉତ୍ତରଗୁଡ଼ିକୁ ସଞ୍ଚୟ କରନ୍ତୁ: ସେଗୁଡ଼ିକୁ ଷ୍ଟାର ଚିହ୍ନ ଦିଅନ୍ତୁ. ଯଦି ଆପଣଙ୍କୁ କୌଣସି ଉତ୍ତର ପସନ୍ଦ ଆସେ, ତେବେ ଉତ୍ତରଗୁଡ଼ିକୁ ସ୍କ୍ରୋଲ୍ କରିବା ବେଳେ ତାହାକୁ ହାଇଲାଇଟ୍ କରିବା ପାଇଁ 'ଷ୍ଟାର୍ ବଟନ୍'କୁ ଦବାନ୍ତୁ।",
  mr: "उत्तरे सेव्ह करा: जर तुम्हाला उत्तर आवडले असेल तर त्यांना स्टार करा, मागील उत्तरे स्क्रोल करताना हायलाइट करण्यासाठी 'स्टार बटण' दाबा."
}
export const tooltipSourceHeading1 = {
  en: "Answers You",
  hi: "स्रोत आधारित,",
  or: "ବିଶ୍ୱାସଯୋଗ୍ୟ",
  mr: "तुम्हाला विश्वास ठेवता"
}
export const tooltipSourceHeading2 = {
  en: "Can Trust",
  hi: "सही उत्तर",
  or: "ଉତ୍ତର",
  mr: "येईल अशी उत्तरे"
}
export const tooltipSourceContent = {
  en: "All answers are from your modules and official documents. Tap the button above for",
  hi: "सभी उत्तर आपकेमॉड्यूल और सरकारी दस्तावेज़ों से लिए गए हैं। ऊपर दिखाया गया बटन दबाएँ और स्त्रोत देखें।",
  or: "ସମସ୍ତ ଉତ୍ତର ଆପଣଙ୍କ ମଡ୍ୟୁଲ୍ ଏବଂ ଅଧିକାରିକ ଦଳିଲରୁ ନିଆଯାଇଛି। ଉପରେ ଥିବା ବଟନ୍‌କୁ ଟାପ୍ କରନ୍ତୁ।",
  mr: "सर्व उत्तरे तुमच्या मॉड्यूल्स आणि अधिकृत कागदपत्रांमधून घेतली आहेत. स्त्रोतांसाठी वरील बटणावर टॅप करा."
}
export const tooltipSourceAudioContent = {
  en: "Answers You Can Trust. All answers are from your modules and official documents. Tap the button above for sources.",
  hi: "स्रोत आधारित, सही उत्तर. सभी उत्तर आपकेमॉड्यूल और सरकारी दस्तावेज़ों से लिए गए हैं। ऊपर दिखाया गया बटन दबाएँ और स्त्रोत देखें।",
  or: "ବିଶ୍ୱାସଯୋଗ୍ୟ ଉତ୍ତର. ସମସ୍ତ ଉତ୍ତର ଆପଣଙ୍କ ମଡ୍ୟୁଲ୍ ଏବଂ ଅଧିକାରିକ ଦଳିଲରୁ ନିଆଯାଇଛି। ଉପରେ ଥିବା ବଟନ୍‌କୁ ଟାପ୍ କରନ୍ତୁ।",
  mr: "तुम्हाला विश्वास ठेवता येईल अशी उत्तरे सर्व उत्तरे तुमच्या मॉड्यूल्स आणि अधिकृत कागदपत्रांमधून घेतली आहेत. स्त्रोतांसाठी वरील बटणावर टॅप करा."
}
export const tooltipEndHeading1 = {
  en: "Now You are",
  hi: "अब आप हैं",
  or: "ବର୍ତ୍ତମାନ ଆପଣ",
  mr: "आता तुम्ही"
}
export const tooltipEndHeading2 = {
  en: "Ready!",
  hi: "रेडी !",
  or: "ରସ୍ତୁତ!",
  mr: "तयार आहात!"
}
export const tooltipEndContent = {
  en: "Now you can use HealthVaani. If you need to learn again, tap the ‘Learn’ button above.",
  hi: "अब आप हेल्थवाणी चला सकती हैं। कुछ भी दोबारा सीखना हो तो ऊपर दिखाए ‘सीखें बटन’ दबाएं।",
  or: "ବର୍ତ୍ତମାନ ଆପଣ ହେଲ୍‌ଥବାଣୀ ବ୍ୟବହାର କରିପାରିବେ। ଯଦି ଆପଣଙ୍କୁ ପୁଣିଥରେ ଶିଖିବାକୁ ପଡ଼େ, ତେବେ ଉପରେ ଥିବା 'ଶିଖନ୍ତୁ' ବଟନ୍‌କୁ ଦବାନ୍ତୁ।",
  mr: "आता तुम्ही हेल्थवाणी वापरू शकता. जर तुम्हाला पुन्हा शिकायचे असेल, तर वरील 'शिका' बटणावर टॅप करा."
}
export const tooltipEndAudioContent = {
  en: "Now You are Ready. Now you can use HealthVaani. If you need to learn again, tap the ‘Learn’ button above.",
  hi: "अब आप हैं रेडी. अब आप हेल्थवाणी चला सकती हैं। कुछ भी दोबारा सीखना हो तो ऊपर दिखाए ‘सीखें बटन’ दबाएं।",
  or: "ବର୍ତ୍ତମାନ ଆପଣ ପ୍ରସ୍ତୁତ! ବର୍ତ୍ତମାନ ଆପଣ ହେଲ୍‌ଥବାଣୀ ବ୍ୟବହାର କରିପାରିବେ। ଯଦି ଆପଣଙ୍କୁ ପୁଣିଥରେ ଶିଖିବାକୁ ପଡ଼େ, ତେବେ ଉପରେ ଥିବା 'ଶିଖନ୍ତୁ' ବଟନ୍‌କୁ ଦବାନ୍ତୁ।",
  mr: "आता तुम्ही तयार आहात! आता तुम्ही हेल्थवाणी वापरू शकता. जर तुम्हाला पुन्हा शिकायचे असेल, तर वरील 'शिका' बटणावर टॅप करा."
}
export const tooltipImage = {
  Intro: ["/Assets/Images/Tooltip/IntroTooltip/IntroTooltip.png"],
  TooltipSpeaker: ["/Assets/Images/Tooltip/NarrationTooltip/NarrationTooltip1.png", "/Assets/Images/Tooltip/NarrationTooltip/NarrationTooltip2.png", "/Assets/Images/Tooltip/NarrationTooltip/NarrationTooltip3.png", "/Assets/Images/Tooltip/NarrationTooltip/NarrationTooltip4.png"],
  TooltipSpeaker2: ["/Assets/Images/Tooltip/NarrationTooltip/NarrationTooltip1.png", "/Assets/Images/Tooltip/NarrationTooltip/NarrationTooltip2.png", "/Assets/Images/Tooltip/NarrationTooltip/NarrationTooltip3.png", "/Assets/Images/Tooltip/NarrationTooltip/NarrationTooltip4.png"],
  TooltipTyping: ["/Assets/Images/Tooltip/TypingTooltip/TypingTooltip1.png", "/Assets/Images/Tooltip/TypingTooltip/TypingTooltip2.png", "/Assets/Images/Tooltip/TypingTooltip/TypingTooltip3.png", "/Assets/Images/Tooltip/TypingTooltip/TypingTooltip4.png", "/Assets/Images/Tooltip/TypingTooltip/TypingTooltip5.png", "/Assets/Images/Tooltip/TypingTooltip/TypingTooltip6.png", "/Assets/Images/Tooltip/TypingTooltip/TypingTooltip7.png"],
  TooltipSend: ["/Assets/Images/Tooltip/SendTooltip/SendTooltip1.png", "/Assets/Images/Tooltip/SendTooltip/SendTooltip2.png", "/Assets/Images/Tooltip/SendTooltip/SendTooltip3.png", "/Assets/Images/Tooltip/SendTooltip/SendTooltip4.png"],
  TooltipMicIntro: ["/Assets/Images/Tooltip/MicTooltip/MicTooltip.png"],
  TooltipMic: ["/Assets/Images/Tooltip/MicTooltip/MicTooltip1.png", "/Assets/Images/Tooltip/MicTooltip/MicTooltip2.png", "/Assets/Images/Tooltip/MicTooltip/MicTooltip3.png", "/Assets/Images/Tooltip/MicTooltip/MicTooltip4.png", "/Assets/Images/Tooltip/MicTooltip/MicTooltip5.png"],
  TooltipMicEnd: ["/Assets/Images/Tooltip/MicTooltip/MicTooltip6.png"],
  TooltipGrid: ["/Assets/Images/Tooltip/GridTooltip/GridTooltip.png"],
  TooltipChips: ["/Assets/Images/Tooltip/ChipsTooltip/ChipsTooltip1.png", "/Assets/Images/Tooltip/ChipsTooltip/ChipsTooltip2.png", "/Assets/Images/Tooltip/ChipsTooltip/ChipsTooltip3.png", "/Assets/Images/Tooltip/ChipsTooltip/ChipsTooltip4.png"],
  TooltipLoader: ["/Assets/Images/Tooltip/TooltipLoader/Loadertooltip.png"],
  TooltipQuestionChips: ["/Assets/Images/Tooltip/QuestionChipsTooltip/QuestionChipsTooltip1.png", "/Assets/Images/Tooltip/QuestionChipsTooltip/QuestionChipsTooltip2.png", "/Assets/Images/Tooltip/QuestionChipsTooltip/QuestionChipsTooltip3.png"],
  TooltipLoader2: ["/Assets/Images/Tooltip/TooltipLoader/Loadertooltip.png"],
  TooltipStar: ["/Assets/Images/Tooltip/StarTooltip/StarTooltip1.png", "/Assets/Images/Tooltip/StarTooltip/StarTooltip2.png"],
  TooltipSource: ["/Assets/Images/Tooltip/SourceTooltip/SourceTooltip1.png", "/Assets/Images/Tooltip/SourceTooltip/SourceTooltip2.png", "/Assets/Images/Tooltip/SourceTooltip/SourceTooltip3.png"],
  TooltipEnd: ["/Assets/Images/Tooltip/EndTooltip/EndTooltip.png"]
}

export const TooltipChecklist = [
  {
    key: "speaker",
    title: {
      en: "‘Speaker button’ learned",
      hi: "‘स्पीकर बटन’ चलना सीखलिया",
      or: "‘ସ୍ପିକର୍ ବଟନ୍’ ଶିଖିଲେ",
      mr: "‘स्पीकर बटण’ शिकले"
    },
    img: "/Assets/Images/Tooltip/TooltipCheckList/CheckListSpeaker.png",
  },
  {
    key: "input",
    title: {
      en: "‘Typing questions’ learned",
      hi: "टाइप कर पूछ्ना सीखलिया",
      or: "‘ପ୍ରଶ୍ନ ଟାଇପ୍ କରିବା’ ଶିଖିଲେ",
      mr: "‘प्रश्न टाइप करणे’ शिकले"
    },
    img: "/Assets/Images/Tooltip/TooltipCheckList/CheckListInput.png",
  },
  {
    key: "mic",
    title: {
      en: "‘Mic button’ learned",
      hi: "‘माइक बटन’ चलना सीखलिया",
      or: "‘ମାଇକ୍ ବଟନ୍’ ଶିଖିଲେ",
      mr: "‘माइक बटण’ शिकले"
    },
    img: "/Assets/Images/Tooltip/TooltipCheckList/CheckListMic.png",
  },
  {
    key: "chips",
    title: {
      en: "‘Topic button’ learned",
      hi: "‘विषय बटन’ चलना सीखलिया",
      or: "‘ଟପିକ୍ ବଟନ୍’ ଶିଖିଲେ",
      mr: "‘विषय बटण’ शिकले"
    },
    img: "/Assets/Images/Tooltip/TooltipCheckList/CheckListChips.png",
  },
  {
    key: "star",
    title: {
      en: "‘Star button’ learned",
      hi: "‘स्टार बटन’ चलना सीखलिया",
      or: "‘ଷ୍ଟାର୍ ବଟନ୍’ ଶିଖିଲେ",
      mr: "‘स्टार बटण’ शिकले"
    },
    img: "/Assets/Images/Tooltip/TooltipCheckList/CheckListStar.png",
  },
  {
    key: "Source",
    title: {
      en: "‘Source button’ learned",
      hi: "‘स्रोत बटन’ चलना सीखलिया",
      or: "‘ଉତ୍ସ ବଟନ୍’ ଶିଖିଲେ",
      mr: "‘स्त्रोत बटण’ शिकले"
    },
    img: "/Assets/Images/Tooltip/TooltipCheckList/CheckListSource.png",
  }
];
